import styled from "styled-components";
import {ReactNode} from "react";

const Styles = {
	Panel: styled.div`
        //border: 1px solid rgba(255, 153, 51, 0.45);
        //background: linear-gradient(135deg, rgba(255, 120, 0, 0.16), rgba(255, 255, 255, 0.03)),
        rgba(0, 0, 0, 0.25);
        //box-shadow: 0 0 22px rgba(255, 122, 0, 0.12);
        padding: 25px 16px 25px 16px;
		margin-top: 10px;
		margin-bottom: 20px;
        //clip-path: polygon(0 0, calc(100% - 18px) 0, 100% 18px, 100% 100%, 18px 100%, 0 calc(100% - 18px));

        position: relative;
        width: 100%;
        max-width: 100%;
        //height: 130px;
        box-sizing: border-box;
        isolation: isolate;
        &::before {
            content: "";
            position: absolute;
            inset: 0;
            z-index: -1;

            background: linear-gradient(
                    180deg,
                    #b45b19 0%,
                    #e27a21 45%,
                    #8a3c0f 100%
            );

            clip-path: polygon(
                    4% 0,
                    44% 0,
                    47% 7%,
                    96% 7%,
                    100% 16%,
                    100% 87%,
                    98% 95%,
                    4% 95%,
                    0 84%,
                    0 17%
            );
        }

        /* Dunkle Innenfläche mit abgeschrägten Ecken */

        &::after {
            content: "";
            position: absolute;
            inset: 1px;
            z-index: -1;

            background: linear-gradient(
                    135deg,
                    #3b1d0c 0%,
                    #2b1409 55%,
                    #231007 100%
            );

            clip-path: polygon(
                    4% 0,
                    44% 0,
                    47% 7%,
                    96% 7%,
                    100% 16%,
                    100% 87%,
                    98% 95%,
                    4% 95%,
                    0 84%,
                    0 17%
            );
        }
	`
}

export const FrameSection = ({ children } :{ children: ReactNode }) =>  <Styles.Panel >{ children }</Styles.Panel>